import { render, staticRenderFns } from "./ImageRectangleCoordinatableObjectDrawer.vue?vue&type=template&id=34d14db0&scoped=true&"
import script from "./ImageRectangleCoordinatableObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./ImageRectangleCoordinatableObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./ImageRectangleCoordinatableObjectDrawer.vue?vue&type=style&index=0&id=34d14db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d14db0",
  null
  
)

export default component.exports